import React from "react";
import { LineC } from "./styles";

export function LineColor({ color }) {
  return (<LineC className={`w-100  bg-${color}`}></LineC>);
}
